import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../html/element'
import { Icon } from '../../../../../html/icon'
import { Input } from '../../../../../html/input'
import {
  changeCreditScore,
  changePerformanceScore,
} from '../../../../store/sliceScoreLevel'
import { TYPE_SCORE_VAlUE } from '../../../constant'
import { getCurrentTime } from '../../../helper'
import classes from '../scoreLevel.module.scss'

export const CustomScore = ({
  typePeriod,
  typePeriodTime,
  item,
  keyId,
  listSelect,
  disable = false,
  isFirst,
}) => {
  const dispatch = useDispatch()
  const { From, To } = item

  const disableStyle = disable
    ? {
        pointerEvents: 'none',
        cursor: 'notAllowed',
        color: '#D5D5D5',
      }
    : {}

  //Actions
  const onChangeFrom = (e) => {
    const value = e.target.value
    if (!/^-?\d+$/.test(value) && value) {
      return
    }

    if (value < 0 || value > 1000) return

    if (typePeriod === TYPE_SCORE_VAlUE.CREDIT_SCORE) {
      dispatch(
        changeCreditScore({
          path: [typePeriodTime, 'custom', keyId, 'From'],
          data: value,
        }),
      )
    }

    if (typePeriod === TYPE_SCORE_VAlUE.PERFORMANCE_SCORE) {
      dispatch(
        changePerformanceScore({
          path: [typePeriodTime, 'custom', keyId, 'From'],
          data: value,
        }),
      )
    }
  }

  const onBlurFrom = (e) => {
    const value = +e.target.value

    if (typePeriod === TYPE_SCORE_VAlUE.CREDIT_SCORE && value > To) {
      dispatch(
        changeCreditScore({
          path: [typePeriodTime, 'custom', keyId, 'From'],
          data: To,
        }),
      )
    }

    if (typePeriod === TYPE_SCORE_VAlUE.PERFORMANCE_SCORE && value > To) {
      dispatch(
        changePerformanceScore({
          path: [typePeriodTime, 'custom', keyId, 'From'],
          data: To,
        }),
      )
    }
  }

  const onChangeTo = (e) => {
    const value = e.target.value
    if (!/^-?\d+$/.test(value) && value) {
      return
    }

    if (value < 0 || value > 1000) return

    if (typePeriod === TYPE_SCORE_VAlUE.CREDIT_SCORE) {
      dispatch(
        changeCreditScore({
          path: [typePeriodTime, 'custom', keyId, 'To'],
          data: value,
        }),
      )
    }

    if (typePeriod === TYPE_SCORE_VAlUE.PERFORMANCE_SCORE) {
      dispatch(
        changePerformanceScore({
          path: [typePeriodTime, 'custom', keyId, 'To'],
          data: value,
        }),
      )
    }
  }

  const onBlurTo = (e) => {
    const value = +e.target.value

    if (typePeriod === TYPE_SCORE_VAlUE.CREDIT_SCORE && value < From) {
      dispatch(
        changeCreditScore({
          path: [typePeriodTime, 'custom', keyId, 'To'],
          data: value ? From : undefined,
        }),
      )
    }

    if (typePeriod === TYPE_SCORE_VAlUE.PERFORMANCE_SCORE && value < From) {
      dispatch(
        changePerformanceScore({
          path: [typePeriodTime, 'custom', keyId, 'To'],
          data: value ? From : undefined,
        }),
      )
    }
  }

  const handleDelete = () => {
    if (typePeriod === TYPE_SCORE_VAlUE.CREDIT_SCORE) {
      if (Object.keys(listSelect).length === 1) {
        dispatch(
          changeCreditScore({
            path: [typePeriodTime, 'custom', keyId],
            data: { From: undefined, To: undefined },
          }),
        )
      } else {
        dispatch(
          changeCreditScore({
            path: [typePeriodTime, 'custom', keyId],
            data: undefined,
          }),
        )
      }
    }

    if (typePeriod === TYPE_SCORE_VAlUE.PERFORMANCE_SCORE) {
      if (Object.keys(listSelect).length === 1) {
        dispatch(
          changePerformanceScore({
            path: [typePeriodTime, 'custom', keyId],
            data: { From: undefined, To: undefined },
          }),
        )
      } else {
        dispatch(
          changePerformanceScore({
            path: [typePeriodTime, 'custom', keyId],
            data: undefined,
          }),
        )
      }
    }
  }

  const handleAdd = () => {
    if (Object.keys(listSelect).length >= 50) return null

    if (typePeriod === TYPE_SCORE_VAlUE.CREDIT_SCORE) {
      dispatch(
        changeCreditScore({
          path: [typePeriodTime, 'custom', getCurrentTime()],
          data: { From: undefined, To: undefined },
        }),
      )
    }
    if (typePeriod === TYPE_SCORE_VAlUE.PERFORMANCE_SCORE) {
      dispatch(
        changePerformanceScore({
          path: [typePeriodTime, 'custom', getCurrentTime()],
          data: { From: undefined, To: undefined },
        }),
      )
    }
  }

  return (
    <>
      <Element
        style={{
          ...disableStyle,
        }}
        className={classes.customRange}
      >
        {isFirst && (
          <div className="dFlex justifyContentBetween alignItemsCenter">
            <Element
              elementName="p"
              style={{
                color: !disable ? '#3A414B' : '#9C9C9C',
                paddingBottom: 6,
                fontWeight: 600,
              }}
            >
              <Translate value="library.filterSetting.CUSTOM_RANGES" />
            </Element>
            <Icon
              style={{ color: '#2C73E8', ...disableStyle }}
              className="icon-plus-circle-fill"
              onClick={handleAdd}
            />
          </div>
        )}
        <div className={['dFlex', classes.groupInput].join(' ')}>
          <Element
            style={{ borderRightColor: '#D5D5D5' }}
            className={['dFlex', classes.groupInputItem].join(' ')}
          >
            <Input
              placeHolder="library.main.FROM"
              containerStyle={{ width: '50%', opacity: disable ? 0.5 : 1 }}
              onChange={onChangeFrom}
              value={From || ''}
              noControl
              onBlur={onBlurFrom}
              isShowIcon={false}
            />
            <Input
              placeHolder="library.main.TO"
              containerStyle={{ width: '50%', opacity: disable ? 0.5 : 1 }}
              onChange={onChangeTo}
              value={To || ''}
              noControl
              onBlur={onBlurTo}
              isShowIcon={false}
            />
          </Element>
          <div className={classes.iconBTS}>
            <Icon
              style={{ color: '#9C9C9C', ...disableStyle }}
              className="icon-trash-fill"
              onClick={handleDelete}
            />
          </div>
        </div>
      </Element>
    </>
  )
}
